var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"graficoTemperatura"}},[_c('apex-charts',{ref:"chart",staticClass:"component apexcharts-canvas",attrs:{"type":"line","height":"300","options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }